import * as React from 'react';
import * as Redux from 'redux';
import * as Tgcc from '../tgccGlobal';
import * as Request from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {Diamonds} from '../Components/Diamonds';
import {BulletLine} from '../Components/BulletLine';
import {PurchaseLinks} from './PurchaseLinks';
import {browserHistory} from 'react-router';

const margBottom = "15px";

const formDiv : React.CSSProperties = {
    textAlign:'center'

}
const input: React.CSSProperties = {
    width:'300px',
    borderRadius:'5px',
    height:'30px',
    marginBottom:margBottom
}

const linkDiv: React.CSSProperties = {
    textAlign:'center'

}
const linkLabel: React.CSSProperties = {
    fontWeight:700,
    fontSize:'20px'
}
const instructions: React.CSSProperties = {
    fontFamily:'Rosewood',
    fontSize:'24px',
    letterSpacing:'2px',
    marginBottom:margBottom
}

const outerLinkDiv: React.CSSProperties = {
    marginBottom:margBottom
}

const helpText: React.CSSProperties = {
    marginBottom:margBottom,
    color:'red'
}
const notes: React.CSSProperties = {
    marginBottom:margBottom,
    color:'blue'
}
const container:React.CSSProperties = {
    height:'100%'
}

class Props extends Tgcc.BaseProps {
    loginData: Tgcc.LoginData;
}
class _CSR extends React.Component<Props, any > {
     
     state = { 
         value: "",
         proof: null,
         error: null,
         codes:[],

    };

    handleChange = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({value: evt.currentTarget.value});
    }
    loadProof = (proof:Tgcc.Proof) => {
        if(proof.rosterCodes !== null){
            this.setState({ proof:proof,codes:proof.rosterCodes});
        }
    }
    onError = (err) => {
        this.setState({error: err});
    }
   
    proofViewLink(){
        var orderNumber = this.state.value;
        var link = "https://www.thegraphiccowcompany.com/proofview?proofId=WO" + orderNumber;
        return (
            <div style={outerLinkDiv}><div style={linkLabel}>View Proof:</div><a className="hoverBorder" href={link}>{link}</a></div>
        )
    }
    proofReviseLink(){
        var orderNumber = this.state.value;
        var link = "https://www.thegraphiccowcompany.com/proofrevise?proofId=WO" + orderNumber;
        return (
            <div style={outerLinkDiv}><div style={linkLabel}>Make Changes:</div><a className="hoverBorder" href={link}>{link}</a></div>
        )
    }
    rosterLinks(){
        var orderNumber = this.state.value;
        var link = "https://www.thegraphiccowcompany.com/proofroster?proofId=WO" + orderNumber;
        return (
            <div style={outerLinkDiv}><div style={linkLabel}>Order Rosters:</div><a className="hoverBorder" href={link}>{link}</a></div>
        )
    }
    tViteLink(){
        var orderNumber = this.state.value;
        var link = "https://www.thegraphiccowcompany.com/tvite?proofId=WO" + orderNumber;
        return (
            <div style={outerLinkDiv}><div style={linkLabel}>T-Vite Sign Up:</div><a className="hoverBorder" href={link}>{link}</a></div>
        )
    }
    tBankerLink(){
        var orderNumber = this.state.value;
        var link = "https://www.thegraphiccowcompany.com/tbanker?proofId=WO" + orderNumber;
        return (
            <div style={outerLinkDiv}><div style={linkLabel}>T-Banker Sign Up:</div><a  className="hoverBorder" href={link}>{link}</a></div>
        )

    }
    getRosterCodes(){
        var webOrder = this.state.value;
        if(webOrder.length === 6) {
            webOrder = "WO" + webOrder;
            return Request.getProof(this.props.loginData, webOrder,this.loadProof,this.onError)
        }
        return null;
    }

     getRosters = () => {
        this.getRosterCodes();
        if(this.state.proof && this.state.codes && this.state.codes){
            var rosters = new Array();
            this.state.codes.map( (value: string) => {
                rosters.push(<PurchaseLinks key={value} rosterCode={value}/>);
            });
            return rosters;
        }
        return null;
    }

    render(){
        var rosters = this.getRosters();
        var proofView = this.proofViewLink();
        var proofRevise = this.proofReviseLink();
        var rosterLinks = this.rosterLinks();
        var tViteLink = this.tViteLink();
        var tBankerLink = this.tBankerLink();
        return (
            <div style={container}>
                <BulletLine text="CSR Page" bulletSize="10px" marginSize="20px" fontFamily="Rosewood" />
                <div style={formDiv}>
                    <div style={instructions}>Type the Web Order Number to generate customer links</div>
                    <div style={helpText}>*You still must create t-bankers, t-vite, etc in order for the links to be active</div>
                    <label>Web Order Number:</label>
                    <input type="text" style={input} placeholder="Ex....560011" onChange={this.handleChange}/>
                    <div style={notes}>*Click to view or Right-Click to copy and paste Url.</div>
                </div>
                <div style={linkDiv}>
                    {proofView}
                    {proofRevise}
                    {rosterLinks}
                    {tViteLink}
                    {tBankerLink}
                    {rosters}
                </div>
            </div>
        )
    }

}



const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    var lData = state.LoginData ? state.LoginData : null;
    return { 
        state: state,
        loginData: lData
    };
};

export var CSR = connect(mapStateToProps)(Radium(_CSR));
